export const ROLES = {
  BOL: {
    HOSTS: {
      CREATE: 'BOL.HOSTS.Create',
      DELETE: 'BOL.HOSTS.Delete',
      READ: 'BOL.HOSTS.Read',
    },
    LOGISTICS_OBJECTS: {
      CREATE: 'BOL.LOGISTICS-OBJECTS.Create',
      DELETE: 'BOL.LOGISTICS-OBJECTS.Delete',
      READ: 'BOL.LOGISTICS-OBJECTS.Read',
      UPDATE: 'BOL.LOGISTICS-OBJECTS.Update',
    },
    MEMBERS: {
      CREATE: 'BOL.MEMBERS.Create',
      DELETE: 'BOL.MEMBERS.Delete',
      READ: 'BOL.MEMBERS.Read',
    },
  },
  BOL_NOTIFICATIONS: {
    SUBSCRIPTIONS: {
      MANAGE: 'BOL.NOTIFICATIONS.SUBSCRIPTIONS.Manage',
    },
  },
} as const;

export const ACTION_ROLE_MAP = {
  createLogisticsObject: ROLES.BOL.LOGISTICS_OBJECTS.CREATE,
  readLogisticsObject: ROLES.BOL.LOGISTICS_OBJECTS.READ,
  updateLogisticsObject: ROLES.BOL.LOGISTICS_OBJECTS.UPDATE,
  deleteLogisticsObject: ROLES.BOL.LOGISTICS_OBJECTS.DELETE,
  createMember: ROLES.BOL.MEMBERS.CREATE,
  readMember: ROLES.BOL.MEMBERS.READ,
  deleteMember: ROLES.BOL.MEMBERS.DELETE,
  createHost: ROLES.BOL.HOSTS.CREATE,
  readHost: ROLES.BOL.HOSTS.READ,
  deleteHost: ROLES.BOL.HOSTS.DELETE,
  manageSubscriptions: ROLES.BOL_NOTIFICATIONS.SUBSCRIPTIONS.MANAGE,
  readSubscription: ROLES.BOL_NOTIFICATIONS.SUBSCRIPTIONS.MANAGE,
} as const;

export type PermissionAction = keyof typeof ACTION_ROLE_MAP;

export const KNOWN_PERMISSION_VALUES = [...new Set(Object.values(ACTION_ROLE_MAP))];

export const getActionTooltip = (action: PermissionAction): string => {
  const role = ACTION_ROLE_MAP[action];
  return `Required role: ${role}`;
};